/* ctr-sticky-cta — reveal the bar once the main CTA has scrolled out of view. */

(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.ctrScInit) return;
    bar.dataset.ctrScInit = 'true';

    var anchor = bar.dataset.anchor || '#buy-box';
    var target = document.querySelector(bar.dataset.watch || '.ctr-buy-box__cta');

    function toggle() {
      if (!target) {
        bar.classList.remove('is-visible');
        return;
      }
      bar.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0);
    }

    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    window.addEventListener('load', toggle);

    bar.querySelectorAll('[data-ctr-sc-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (anchor.charAt(0) !== '#') return;
        var dest = document.querySelector(anchor) || target;
        if (!dest) return;
        e.preventDefault();
        dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ctr-sticky-cta]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
